<template>
  <b-card
    class="boxNews mb-0"
    style="height: 100%; max-height: 415px;"
    no-body
  >
    <b-card-header class="p-1 backgroundCardHeader">
      <div class="col-12 p-0 d-flex">
        <div class="w-90 text-nowrap">
          <h3 class="card-title">
            <router-link
              :to="{ name: 'home-category', params: { slug: item.slug } }"
              class="d-flex align-items-center"
              :title="item.name"
            >
              <span :class="renderIconCategory(item.name)" />
              <span class="font-be-vietnam font-size20-be-vietnam text-dark font-weight-700 ml-1">{{ capFirst(item.name) }} </span> <span class="icon_arrow" /></router-link>
          </h3>
        </div>
        <div class="w-10 ml-auto">
          <router-link :to="{ name: 'home-category', params: { slug: 'audio' } }">
            <span class="default_arrow justify-content-end" />
          </router-link>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="px-0 py-1">
      <vue-perfect-scrollbar
        ref="refListPS"
        :settings="perfectScrollbarSettings"
        class="home-scroll-area"
      >
        <ul class="new-list px-1">
          <li
            v-for="(data) in item.articles"
            :key="data.id"
          >
            <div class="col-12 p-0 ">

              <h3 class="news-title">
                <router-link
                  :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
                  class="link "
                  :title="data.title"
                >
                  <span :class="renderClassTitleHot(data)"> {{ data.title }}</span>
                  <span
                    v-if="data.hot"
                    class="iconHotGif"
                  />
                  <span
                    v-if="data.is_get"
                    class="iconNewsRead"
                  />

                </router-link>
              </h3>
            </div>
            <div class="news-icon col-12 d-flex p-0">
              <!-- <div class="news-icon d-flex  "> -->
              <div class="w-30 d-flex pr-1">
                <span
                  v-for=" (type, key) in data.content_type"
                  :key="key"
                  class="mr-0"
                >
                  <span
                    v-if="type === 'audio'"
                    class="iconAudioBlue mr-5px"
                  />
                  <span
                    v-if="type === 'photo'"
                    class="iconPhotoBlue mr-5px"
                  />
                  <span
                    v-if="type === 'video'"
                    class="iconVideoBlue mr-5px"
                  />
                </span>
              </div>
              <!-- <div class="w-70 d-flex p-0 justify-content-end">
              <div class="m-0 w-50 text-right pr-5px">
                {{ (data.timeago) }}
              </div>

              <div
                v-if="data.unit"
                class="w-50 text-right pr-5px"
              >
                <span class="icon m-0" />{{ showListPart(data.unit) }}
              </div>
            </div> -->
              <div class="w-70 d-flex  justify-content-end">
                <span> {{ (data.timeago) }}</span>
                <span
                  v-if="data.unit"
                  class="icon font-size13-be-vietnam"
                  style="padding-left: 10px;"
                > {{ showListPart(data.unit) }}</span>
              </div>

              <!-- </div> -->

            </div>
          </li>

        </ul>
      </vue-perfect-scrollbar>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BCardHeader,
  BRow,
  BCol,
  BButton,
  BImg,
  BLink,
} from 'bootstrap-vue';
import { timeago } from '@/libs/helper';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BImg,
    BRow,
    BCol,
    BButton,
    BLink,
    BCardHeader,
    VuePerfectScrollbar,
  },
  props: {
    item: {
      type: Object,
      default: Object,
    },
    showIcon: {
      type: String,
      default: 'FileTextIcon',
    },
  },
  setup(props, context) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };
    return {
      perfectScrollbarSettings,
    }
  },
  methods: {
    resolveTimeago(time) {
      return timeago(time);
    },
    capFirst(str) {
      const str1 = str.toLowerCase()
      return str1[0].toUpperCase() + str1.slice(1);
    },
    showListPart(str) {
      return str.split(',').slice(0, 3).join(',');
    },
    renderClassTitleHot(item) {
      // 1. Tin bình thường mầu đen

      // 2. Tin đã click màu ghi
      // 3. Tin hot màu đỏ tười có iconhot
      // 4. TIn đã lấy màu nâu đỏ có icon xanh
      // 5. Tin hot đã click màu ghi có icon hot
      // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
      let classTitle = 'class_title_normall';
      if (item.hot) {
        if (item.is_get) { // đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_get_view'
          } else {
            classTitle = 'class_title_hot_get_notview'
          }
        } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_notget_view'
          } else {
            classTitle = 'class_title_hot_notget_notview' // tin hot chưa lấy chưa đọc
          }
        }
      } else if (!item.hot) {
        if (item.is_get) { // tin đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_nothot_get_view'
          } else {
            classTitle = 'class_title_nothot_notget_notview'
          }
        } else if (!item.is_get) {
          if (item.is_view) { // tin bt nhưng đã xem chưa lấy
            classTitle = 'class_title_nohot_notget_view'
          } else {
            classTitle = 'class_title_nohot_notget_notview'
          }
        }
      }

      return classTitle;
    },

    renderIconCategory(name) {
      let classIcon = 'tin_ban_trong_nuoc';
      if (name.match(/chính/i)) {
        classIcon = 'tin_chinh_tri'
      }
      if (name.match(/xã/i)) {
        classIcon = 'tin_xa_hoi'
      }
      if (name.match(/văn/i)) {
        classIcon = 'tin_van_hoa'
      }
      if (name.match(/luật/i)) {
        classIcon = 'tin_phap_luat'
      }
      if (name.match(/giới/i)) {
        classIcon = 'tin_the_gioi'
      }
      if (name.match(/tế/i)) {
        classIcon = 'tin_kinh_te'
      }

      return classIcon;
    },
  },
}
</script>
<style lang="scss">
.home-scroll-area {
  position: relative;
  height: 100%;
}
</style>
